import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { ResourcesCounts } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  counts: ResourcesCounts;
  retrievePlanzoneResourcesCounts(
    request: Boundaries["retrievePlanzoneResourcesCounts"]["request"],
  ): void;
}

function useRetrievePlanzoneResourcesCounts(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrievePlanzoneResourcesCountsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrievePlanzoneResourcesCountsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrievePlanzoneResourcesCountsRequestFailure,
    ),
    counts: useSelector(selector.getPlanzoneResourcesCounts),
    retrievePlanzoneResourcesCounts: core.retrievePlanzoneResourcesCounts,
  };
}

export { useRetrievePlanzoneResourcesCounts };
